<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        Attendees
      </h3>
    </div>
    <div
      class="dimmer"
      :class="{ 'active': loading }"
    >
      <div class="loader" />
      <div class="dimmer-content">
        <div class="table-responsive">
          <table class="table card-table table-striped table-vcenter">
            <thead>
              <tr>
                <th>Attendee</th>
                <th>Hash</th>
                <th>TicketType</th>
                <th>Entered</th>
                <th>Date</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="attendee in attendees"
                :key="attendee.ticketId"
              >
                <td>{{ attendee.ticketHolderFullName }}</td>
                <td>{{ attendee.ticketHash }}</td>
                <td>{{ attendee.ticketClass }}</td>
                <td>{{ attendee.numberEntered }} / {{ attendee.numberOfEntries }}</td>
                <td class="text-nowrap">
                  {{ attendee.logTime }}
                </td>
                <td class="w-1">
                  <router-link
                    :to="{ path: `/${attendee.ticketId}/entry` }"
                    class="icon"
                  >
                    <i class="fe fe-camera" />
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/Api'

export default {
    name: 'Attendees',
    data: () => ({
        eventId: null,
        loading: true,
        attendees: [],
    }),
    mounted: function() {
        this.eventId = this.$route.params.id
        this.loading = true
        api.getAttendees(this.eventId).then(attendees => {
            this.attendees = attendees
            this.loading = false
        })
    },
}
</script>
